<template>
  <Modal max-width="600" :title="modalContent.title" title-section-mobile="Ativar CDN" controlsDirection="right">
    <p class="text-paragraph-2">{{modalContent.subTitle}}</p>
    <p class="text-paragraph-2">{{modalContent.subTitle2}}</p>
    <Link href="https://ajuda.locaweb.com.br/wiki/saiba-como-ativar-e-desativar-o-cdn-em-sua-hospedagem-wordpress-locaweb/#ativacao-do-cdn" target="blank" color="primary" class="ml-n1 mt-4">Saiba Como Ativar e Configurar CDN</Link>
    <template #append>
      <Button label="Talvez outra hora" text color="primary" @click="toggleModal" />
      <Button v-bind="buttonProps" @click="cdnUpdate"/>
    </template>
  </Modal>
</template>

<script>
import { Button, Modal, Link } from '@locaweb/design-system-vue'
import { findDomainStatus, updateCdn } from '@/views/site/api/site.api'

export default {
  components: { Button, Modal, Link },
  props: ['filteredData', 'idSite'],
  data () {
    return {
      statusDomain: {},
      error: '',
      filteredSite: {}
    }
  },
  methods: {
    async findCdnStatus () {
      try {
        const idNumber = Number(this.idSite)
        const data = this.filteredData.filter((item) => item.id === idNumber)
        const statusDomain = await findDomainStatus(data[0].domain)
        this.statusDomain = statusDomain.data
      } catch (e) {
        this.error = true
        this.$notify.show({ message: 'error', timeout: 4000, state: 'error' })
      }
    },
    findFilteredSite () {
      const idNumber = Number(this.idSite)
      const data = this.filteredData.filter((item) => item.id === idNumber)
      this.filteredSite = data[0]
    },
    toggleModal () {
      this.$emit('closeCancel')
    },
    cdnUpdate () {
      let cdn = true
      if (this.statusCdn) {
        cdn = false
      }
      const wordpressId = this.filteredSite.wordpress_id
      updateCdn(this.idSite, cdn, wordpressId)
      this.$emit('closeModal')
    }
  },
  computed: {
    statusCdn () {
      const idNumber = Number(this.idSite)
      const data = this.filteredData.filter((item) => item.id === idNumber)
      return data[0].cdn
    },
    modalContent () {
      const content = {
        false: {
          title: 'Ativar CDN',
          subTitle: 'Para usar CDN é necessário escolher um provedor deste serviço e fazer as configuração.',
          subTitle2: 'Depois de fazer as configurações, você poderá ativá-la aqui na Locaweb.',
          titleButton: 'Ativar CDN'
        },
        true: {
          title: 'Desativar CDN',
          subTitle: 'Para voltar a usar seu site sem o CDN, você precisa excluir a entradas do seu provedor e recriar as entradas DNS voltadas para o seu provedor de domínio.',
          subTitle2: '',
          titleButton: 'Desativar CDN'
        }
      }
      return content[this.filteredSite.cdn]
    },
    buttonProps () {
      let items = {
        disabled: false,
        label: this.modalContent.titleButton,
        color: 'primary'
      }

      if (!this.statusCdn) {
        items = {
          disabled: false,
          label: this.modalContent.titleButton,
          color: 'primary'
        }
        if (this.statusDomain.status) {
          items = {
            disabled: true,
            label: this.modalContent.titleButton
          }
        }
      }
      return items
    }
  },
  mounted () {
    this.findFilteredSite()
    this.findCdnStatus()
  }
}
</script>
